import { ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { GroupsService } from 'core/services';

export const GroupResolver: ResolveFn<any> = (
  route?: ActivatedRouteSnapshot,
  state?: RouterStateSnapshot,
  groupsService: GroupsService = inject(GroupsService),
  router: Router = inject(Router)
): Promise<any> => {
  return new Promise((resolve, reject) => {
    const groupId = route.paramMap.get('groupId') || route.queryParamMap.get('groupId');
    if (!groupId) resolve(null);

    groupsService.fetch({ _id: groupId, aggregates: ['studentsCount', 'licensesResume'] }).then(
      (remoteGroup) => {
        if (remoteGroup.docs) {
          resolve(remoteGroup.docs[0]);
        } else {
          // TODO: Delete when backends back the 404 not found, add navigation in an interceptor
          router.navigate(['not-found'], { replaceUrl: true }).then();
          resolve(null);
        }
      },
      (err) => reject(err)
    );
  });
};
